'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconForwardSlash, iconForwardSlashTag } from '@ni/nimble-components/dist/esm/icons/forward-slash';
import { wrap } from '../../utilities/react-wrapper';

export type { IconForwardSlash };
export { iconForwardSlashTag };
export const NimbleIconForwardSlash = wrap(IconForwardSlash);